import type { FC } from "react";

import type { OrderItem as CartItem } from "@jti/magento";
import { ProductMiniature, useTranslations } from "@jti/ui";
import { StrengthIndicator } from "@jti/ui/components/StrengthIndicator";

import { SummaryCartItemPrice } from "../SummaryCartItemPrice";

import { SummaryCartItemsGiftBadge } from "./SummaryCartItemsGiftsBadge";
import SummaryCartItemsTrialsBadge from "./SummaryCartItemsTrialsBadge";

import styles from "./SummaryCartItems.module.scss";

interface SummaryCartItemProps extends CartItem {
  isFreeTrial: boolean;
}

const SummaryCartItem: FC<SummaryCartItemProps> = ({
  id,
  name,
  imageUrl,
  price: { currency, value: price },
  quantity,
  isFreeTrial,
  isGift,
  nicotineStrength,
}) => {
  const { __ } = useTranslations();

  return (
    <li className={styles.product} key={id} data-testid="summaryCartItem">
      {imageUrl && <ProductMiniature imageUrl={imageUrl} showTitle={false} name={name} />}

      <div>
        <div className={styles.name}>{name}</div>
        {nicotineStrength && <StrengthIndicator name={nicotineStrength.name} strength={nicotineStrength.rating} />}
        <SummaryCartItemsTrialsBadge isFreeTrial={isFreeTrial} className={styles.badge} />
        {isGift && <SummaryCartItemsGiftBadge className={styles.badge} />}
      </div>
      <div className={styles.nameQuantityPrice}>
        <div className={styles.quantity}>
          {__("cart.payment_summary.qty")}: {quantity}
        </div>
        <SummaryCartItemPrice price={isGift ? 0 : price} currency={currency} isFreeTrial={isFreeTrial} />
      </div>
    </li>
  );
};

export default SummaryCartItem;
